/**
 * Marca, POR DISPOSITIVO, que este navegador já foi usado por uma incorporadora
 * (ambiente B2B logado). Serve para o isolamento dos mundos: a landing de vendas
 * ("/") é só para quem NÃO é usuário; um cliente já conhecido que cai em "/"
 * deslogado (bookmark, logo, PWA, sessão expirada) vai para o LOGIN (/entrar),
 * nunca para o site de vendas.
 */
const CHAVE = 'ama_b2b_cliente';

export function marcarClienteB2B(): void {
  try {
    localStorage.setItem(CHAVE, '1');
  } catch {
    /* localStorage indisponível — no pior caso o cliente vê a landing em "/". */
  }
}

export function ehClienteB2BConhecido(): boolean {
  try {
    return localStorage.getItem(CHAVE) === '1';
  } catch {
    return false;
  }
}
